
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/[page]",
      function () {
        return require("private-next-pages/legal/[page].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal/[page]"])
      });
    }
  